export default __webpack_public_path__ + "static/media/nocart.f07b05db.svg";